var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsrbE10Plus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.418,
    height: 90.627,
    viewBox: "0 0 60.418 90.627",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(-830 -867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(830.001 867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M163.085,513.454H102.667v90.627h60.418V513.454Z",
    transform: "translate(-102.667 -513.454)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(0.878 0.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M161.906,514.093v88.685H103.244V514.093h58.662",
    transform: "translate(-103.244 -514.093)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 52.336,
    height: 14.706,
    transform: "translate(2.951 3.152)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 52.366,
    height: 54.061,
    transform: "translate(2.928 21.064)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(2.938 78.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M105.174,572.707v-7.178h10.513v1.68H109.4v1.026h5.323v1.674H109.4v1.124h6.534v1.674Z",
    transform: "translate(-105.174 -565.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M120.638,567.68a.8.8,0,0,0-.611-.484,3.776,3.776,0,0,0-1.09-.134c-.93,0-1.346.152-1.346.42,0,1.061,7.414.394,7.414,3.005,0,1.663-2.492,2.474-6.033,2.474-3.4,0-5.619-1.105-5.709-2.4h4.044a1.027,1.027,0,0,0,.7.565,3.827,3.827,0,0,0,1.2.181c1.057,0,1.758-.187,1.758-.525,0-1.089-7.419-.343-7.419-3.078,0-1.526,2.364-2.29,5.589-2.29,3.578,0,5.208,1.014,5.517,2.268Z",
    transform: "translate(-100.948 -565.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M126.58,568.642h1.661c1.306,0,2.008-.19,2.008-.684s-.716-.749-1.7-.749H126.58Zm0,1.565v2.5h-4.225v-7.178h6.09c4.29,0,5.708.658,5.708,2.052,0,.83-.661,1.519-2.165,1.76,1.358.274,2.183.443,2.183,1.891,0,.935-.055,1.259.446,1.259v.216h-4.281a2.759,2.759,0,0,1-.212-1.255c0-.942-.286-1.245-2.255-1.245Z",
    transform: "translate(-96.197 -565.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M136.029,567.21v1.2h1.76c.842,0,1.452-.218,1.452-.627,0-.562-.831-.574-1.72-.574Zm0,2.5v1.325h1.844c1.047,0,1.831-.122,1.831-.658,0-.627-.98-.667-2.331-.667Zm-4.22,3v-7.178h6.16c2.9,0,5.211.39,5.211,1.812,0,.74-.862,1.279-1.682,1.557,1.395.2,2.142.874,2.142,1.644,0,1.6-2.2,2.165-5.549,2.165Z",
    transform: "translate(-91.258 -565.351)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(6.898 24.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M133.307,567.666h-2.255v1.241h2.255v2.188h1.28v-2.188h2.261v-1.241h-2.261v-2.194h-1.28Zm-3.591-.556c0-4.362-2.337-6.944-6.215-6.944-5.24,0-6.531,3.581-6.531,6.944,0,4.108,2.061,6.944,6.375,6.944s6.371-2.836,6.371-6.944m-21.94-27.724,31.713-9.47,3.176,10.044-15.885,4.74,1.3,4.106,14.678-4.377,3.171,10.045-14.669,4.374,1.37,4.328,16.409-4.9,3.182,10.036-32.232,9.626-12.213-38.552m1.209,25.4a10.687,10.687,0,0,0,3.94-1.9v10.5H115.9V560.22H113a10.372,10.372,0,0,1-4.018,2.022v2.549",
    transform: "translate(-107.775 -529.917)",
    fill: "#1a1818"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(11.933 31.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M115.613,556.126c.023-4.4,1.768-5.426,3.768-5.42,2.236.011,3.508,1.682,3.493,5.543-.014,2.409-.664,5.362-3.529,5.345-2.807-.011-3.748-2.253-3.732-5.469",
    transform: "translate(-115.613 -550.706)",
    fill: "#1a1818"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(4.426 6.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M106.151,526.6v-8.343h3.269v1.285H107.4V521.6h1.857v1.283H107.4v2.439h2.081v1.28Z",
    transform: "translate(-106.151 -518.118)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M108.56,518.255h1.3l.93,6.067h.017l1.044-6.067h1.238L111.5,526.6h-1.468Z",
    transform: "translate(-104.892 -518.118)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M111.9,526.6v-8.343h3.269v1.285h-2.017V521.6h1.857v1.283h-1.857v2.439h2.083v1.28Z",
    transform: "translate(-103.145 -518.118)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M115.865,526.6h-1.253v-8.343h2.314a1.173,1.173,0,0,1,1.023.556,2.887,2.887,0,0,1,.381,1.629,3.254,3.254,0,0,1-.254,1.351,1.189,1.189,0,0,1-.859.7v.021c.065.018.16.039.28.072a.826.826,0,0,1,.364.207,1.331,1.331,0,0,1,.309.48,2.357,2.357,0,0,1,.132.883c0,.131,0,.317.006.556s.008.486.021.74.024.489.044.7a2.382,2.382,0,0,0,.07.449h-1.227a2.665,2.665,0,0,1-.129-.8c0-.277,0-.55,0-.821,0-.247,0-.483,0-.7a2.078,2.078,0,0,0-.081-.585.82.82,0,0,0-.266-.4.85.85,0,0,0-.544-.151h-.323Zm0-4.736h.556a.439.439,0,0,0,.308-.116.826.826,0,0,0,.2-.3,1.565,1.565,0,0,0,.105-.4,3.381,3.381,0,0,0,.027-.417,1.55,1.55,0,0,0-.171-.849.536.536,0,0,0-.467-.247h-.556Z",
    transform: "translate(-101.73 -518.118)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M118.84,523.711l-1.57-5.456h1.37l.894,3.524.956-3.524h1.277l-1.676,5.456V526.6H118.84Z",
    transform: "translate(-100.342 -518.118)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M122.631,526.784a1.763,1.763,0,0,1-1.192-.364,2.054,2.054,0,0,1-.617-.97,5.5,5.5,0,0,1-.224-1.381c-.02-.516-.032-1.049-.032-1.6s.012-1.09.032-1.606a5.45,5.45,0,0,1,.224-1.375,2.076,2.076,0,0,1,.617-.965,2.147,2.147,0,0,1,2.387,0,2.072,2.072,0,0,1,.614.965,5.255,5.255,0,0,1,.224,1.375c.023.516.032,1.052.032,1.606s-.009,1.079-.032,1.6a5.3,5.3,0,0,1-.224,1.381,2.05,2.05,0,0,1-.614.97A1.769,1.769,0,0,1,122.631,526.784Zm0-1.247a.538.538,0,0,0,.425-.178,1.274,1.274,0,0,0,.241-.551,5.5,5.5,0,0,0,.107-.953q.025-.582.026-1.381t-.026-1.379a5.517,5.517,0,0,0-.107-.955,1.246,1.246,0,0,0-.241-.547.584.584,0,0,0-.848,0,1.213,1.213,0,0,0-.238.547,5.48,5.48,0,0,0-.11.955q-.025.585-.024,1.379t.024,1.381a5.458,5.458,0,0,0,.11.953,1.24,1.24,0,0,0,.238.551A.542.542,0,0,0,122.631,525.537Z",
    transform: "translate(-98.619 -518.165)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M123.94,526.6v-8.343h1.691l1.592,5.778h.017v-5.778h1.169V526.6h-1.652l-1.632-6.1h-.018v6.1Z",
    transform: "translate(-96.857 -518.118)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M127.568,526.6v-8.343h3.267v1.285h-2.014V521.6h1.857v1.283h-1.857v2.439H130.9v1.28Z",
    transform: "translate(-94.961 -518.118)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M131.426,519.564a5.443,5.443,0,0,0,.6-.559,3.5,3.5,0,0,0,.518-.728h1.107v8.308H132.4v-6.391a4.777,4.777,0,0,1-.47.5c-.169.149-.338.294-.507.428Z",
    transform: "translate(-92.946 -518.106)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M135.362,518.208a1.566,1.566,0,0,1,.863.215,1.357,1.357,0,0,1,.51.713,5.243,5.243,0,0,1,.239,1.312c.04.537.064,1.2.064,2q0,.977-.044,1.768a5.864,5.864,0,0,1-.207,1.352,1.862,1.862,0,0,1-.51.862,1.532,1.532,0,0,1-1.833,0,1.845,1.845,0,0,1-.505-.862,5.763,5.763,0,0,1-.212-1.352c-.026-.527-.041-1.116-.041-1.768q0-1.19.062-2a5.038,5.038,0,0,1,.241-1.312,1.354,1.354,0,0,1,.507-.713A1.549,1.549,0,0,1,135.362,518.208Zm0,1.215a.357.357,0,0,0-.289.117.976.976,0,0,0-.151.448,7.223,7.223,0,0,0-.059.923c0,.4-.006.917-.006,1.559,0,.627,0,1.139.012,1.536a6.379,6.379,0,0,0,.068.929,1.012,1.012,0,0,0,.151.458.33.33,0,0,0,.274.125.335.335,0,0,0,.273-.125,1.025,1.025,0,0,0,.154-.458,6.843,6.843,0,0,0,.069-.929c.006-.4.012-.909.012-1.536,0-.643,0-1.163-.009-1.559a6.7,6.7,0,0,0-.059-.923.905.905,0,0,0-.154-.448A.36.36,0,0,0,135.362,519.423Z",
    transform: "translate(-91.765 -518.143)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M137.543,519.319h.92V521.6h1.4v1.282h-1.4v2.276h-.92v-2.276h-1.411V521.6h1.411Z",
    transform: "translate(-90.487 -517.562)",
    fill: "#1a1818"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsrbE10Plus);
export default __webpack_public_path__ + "static/media/esrb-e10plus.da10740472cdc84aeb944242f1a54d64.svg";
export { ForwardRef as ReactComponent };